import flatpickr from "flatpickr";

const widgets = document.querySelectorAll('input[type="date"]');
[...widgets].forEach(widget => {
	var maxDate = widget.getAttribute("data-maxdate");
	var minDate = widget.getAttribute("data-mindate");
	console.log(maxDate);
	var options = {
		allowInput:true,
		onOpen: function(selectedDates, dateStr, instance) {
			$(instance.altInput).prop('readonly', true);
		},
		onClose: function(selectedDates, dateStr, instance) {
			$(instance.altInput).prop('readonly', false);
			$(instance.altInput).blur();
		},
		altInput: true,
		altInputClass: "flatpickr-input",
		altFormat: "d.m.Y",
		minDate: minDate,
		maxDate: maxDate,
		locale: {
			"firstDayOfWeek": 1 // start week on Monday
		},
		disable: [
			function(date) {
				// return true to disable
				return widget.getAttribute("data-onlyworkingdays") == 'true' && (date.getDay() === 0 || date.getDay() === 6);
			}
		]
	};
	if (minDate) options.minDate = minDate;
	if (maxDate) options.maxDate = maxDate;
	flatpickr(widget, options);
});
